// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Eyjc","info":"PatientInfo_info__kiVXg"};